import PropTypes from 'prop-types';
import React from 'react';
import { isNil } from 'ramda';
import Money from '../../common/money';

const CustomerPaymentViewHeader = ({ children, total, subtitle }) => (
  <div className="o-customer-payment-view__header">
    {children || [
      <div className="c-customer-view-title" key="title" data-automation-id="text:paymentTotal">
        <Money display-if={!isNil(total)}>{total}</Money>
      </div>,
      <div className="c-customer-view-subtitle" key="subtitle">
        {subtitle}
      </div>,
    ]}
  </div>
);
CustomerPaymentViewHeader.propTypes = {
  children: PropTypes.node,
  total: PropTypes.number,
  subtitle: PropTypes.string,
};
CustomerPaymentViewHeader.defaultProps = {
  children: null,
  total: null,
  subtitle: null,
};

export default CustomerPaymentViewHeader;
